import { createContext, useCallback, useEffect, useMemo, useReducer } from 'react';
import { loggingMiddleware } from '../../utils/store';
import { initialState, reducer, RESET_ERROR, SET_API_OUTAGE, SET_APP_NAME, SET_CALL_OBJECT_OUTAGE, SET_ERROR, SET_EXTERNAL_OUTAGE, SET_STORE_BEFORE_INIT } from './reducer';
import { jsx as _jsx } from "react/jsx-runtime";
export const ErrorContext = /*#__PURE__*/createContext(initialState);

// this variable being used in case if we trigger actions
// before context is initialized
let storeBeforeInit = {
  message: '',
  showError: false,
  ctaFunction: () => {},
  isExternalOutage: false,
  appName: 'in-meeting-experience-ui-components',
  isApiCallObjectOutage: false,
  isApiOutage: false
};
export let errorDispatch = arg => {
  if (arg.type === SET_ERROR || arg.type === SET_EXTERNAL_OUTAGE) {
    storeBeforeInit = Object.assign({}, storeBeforeInit, arg.payload);
  }
  if (arg.type === SET_API_OUTAGE) {
    storeBeforeInit = Object.assign({}, storeBeforeInit, {
      isApiOutage: arg.payload
    });
  }
};
export const actions = {
  setError: data => errorDispatch({
    type: SET_ERROR,
    payload: data
  }),
  resetError: () => errorDispatch({
    type: RESET_ERROR
  }),
  setExternalOutage: value => errorDispatch({
    type: SET_EXTERNAL_OUTAGE,
    payload: value
  }),
  setCallObjectOutage: value => errorDispatch({
    type: SET_CALL_OBJECT_OUTAGE,
    payload: value
  }),
  setApiOutage: value => errorDispatch({
    type: SET_API_OUTAGE,
    payload: value
  })
};
export const ErrorContextProvider = ({
  children,
  appName
}) => {
  const [error, dispatchCTX] = useReducer(loggingMiddleware('error')(reducer), initialState);
  const dispatch = useCallback(action => {
    dispatchCTX(action);
  }, []);
  errorDispatch = dispatch;
  const state = useMemo(() => Object.assign({}, error, {
    dispatch
  }), [error, dispatch]);

  // set storeBeforeInit to keep changes which
  // have been done before context initialization
  useEffect(() => {
    dispatch({
      type: SET_STORE_BEFORE_INIT,
      payload: storeBeforeInit
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // set appName prop if provied
  useEffect(() => {
    if (appName && error.appName !== appName) {
      dispatch({
        type: SET_APP_NAME,
        payload: appName
      });
    }
  }, [appName, dispatch, error.appName]);
  return /*#__PURE__*/_jsx(ErrorContext.Provider, {
    value: state,
    children: children
  });
};